// extracted by mini-css-extract-plugin
export default {"titleWrapper":"ColumnModal_titleWrapper__058aj","elementModal":"ColumnModal_elementModal__VqHdY","form":"ColumnModal_form__B2lAC","modalIcon":"ColumnModal_modalIcon__70s1a"};